"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
require("core-js");
var moment = require("moment");
var React = require("react");
var react_dates_1 = require("react-dates");
var Cooltip_1 = require("../Cooltip");
require("./DatePicker.scss");
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFocused: false,
        };
        // tslint:disable-next-line:no-string-literal
        moment.locale(navigator.languages ? navigator.languages[0] : (navigator.language || navigator['userLanguage']));
        _this.onFocusChange = _this.onFocusChange.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    DatePicker.prototype.onChange = function (date) {
        var adjDate = null;
        if (date) {
            adjDate = date.subtract(12, "h");
        }
        this.props.onDateChange(adjDate);
    };
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, errorMessage = _a.errorMessage, isOutsideRange = _a.isOutsideRange, validationState = _a.validationState, rest = __rest(_a, ["errorMessage", "isOutsideRange", "validationState"]);
        var rangeFunc = isOutsideRange;
        if (!isOutsideRange) {
            rangeFunc = function () { return false; };
        }
        var validationClass = "";
        if (validationState === "invalid") {
            validationClass = "invalid";
        }
        else if (validationState === "valid") {
            validationClass = "valid";
        }
        var datePickerClassNames = classNames({}, validationClass);
        var highlightTodayFunc = function (day) { return react_dates_1.isSameDay(day, moment()); };
        var initialMonth = function () { return _this.props.date ? moment(_this.props.date) : null || _this.props.initialDisplayDate ? moment(_this.props.initialDisplayDate) : null || moment(); };
        //hax by Cody
        var missingTypesProperties = {
            firstDayOfWeek: this.props.firstDayOfWeek,
            isDayBlocked: function (day) {
                if (_this.props.disabledDays && _this.props.disabledDays.indexOf(day.weekday()) !== -1) {
                    return true;
                }
                return false;
            }
        };
        var datePicker = (React.createElement("div", { className: datePickerClassNames },
            React.createElement(react_dates_1.SingleDatePicker, __assign({}, missingTypesProperties, { date: this.props.date ? moment(this.props.date) : null, disabled: this.props.disabled, onDateChange: this.props.datesTimestampedMidnight ? this.onChange : this.props.onDateChange, id: this.props.id, focused: this.state.isFocused, onFocusChange: this.onFocusChange, placeholder: this.props.placeholder || moment.localeData().longDateFormat('L'), numberOfMonths: 1, isOutsideRange: rangeFunc, isDayHighlighted: highlightTodayFunc, initialVisibleMonth: initialMonth }))));
        if (this.props.validationState === "invalid"
            && this.props.errorMessage
            && this.props.errorMessage !== "") {
            return React.createElement(Cooltip_1.Cooltip, { tooltipType: 'error', tooltipContents: React.createElement("span", null, this.props.errorMessage), placement: 'bottom' }, datePicker);
        }
        else {
            return datePicker;
        }
    };
    DatePicker.prototype.onFocusChange = function (_a) {
        var focused = _a.focused;
        this.setState({
            isFocused: focused
        });
    };
    return DatePicker;
}(React.Component));
exports.DatePicker = DatePicker;
var Weekday;
(function (Weekday) {
    Weekday[Weekday["sunday"] = 0] = "sunday";
    Weekday[Weekday["monday"] = 1] = "monday";
    Weekday[Weekday["tuesday"] = 2] = "tuesday";
    Weekday[Weekday["wednesday"] = 3] = "wednesday";
    Weekday[Weekday["thursday"] = 4] = "thursday";
    Weekday[Weekday["friday"] = 5] = "friday";
    Weekday[Weekday["saturday"] = 6] = "saturday";
})(Weekday = exports.Weekday || (exports.Weekday = {}));
//# sourceMappingURL=DatePicker.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/DatePicker/DatePicker.js
// module id = 582
// module chunks = 1